import { inject, injectable } from 'inversify';
import Debug from 'debug';
import { TrackingService2, TrackingService2Symbol, createQuery } from '@/app/tracking/api';
import { ExamResultStoreModule, ExamResultStoreModuleSymbol } from '../../state';
import { QueryExamResultsTrackingQuery } from '../../tracking/api';

const debug = Debug('query-exams-tracking-state-command');

@injectable()
export class QueryExamsTrackingStateCommandHandler {

  constructor(
    @inject(TrackingService2Symbol)
    private trackingService: TrackingService2,
    @inject(ExamResultStoreModuleSymbol)
    private examResultStore: ExamResultStoreModule) {
  }

  public async execute() {

    debug(`querying exams' tracking state`);

    this.examResultStore.startRemoteQuerying();

    const query = createQuery<QueryExamResultsTrackingQuery>('query-exam-results', {})
    const result = await this.trackingService.query(query)

    const states = result.exams.map((x) => ({ ...x }));
    debug(`exams' remote tracking state queried: %j`, states);
    this.examResultStore.finishRemoteQuerying(states);
  }
}
